import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { SignInForm } from "@tradersage/shared";
import { auth, analytics } from "@/util/firebase";
import { logEvent } from "firebase/analytics";

export const Route = createFileRoute("/_auth/signin")({
  component: SignInPage,
  staticData: {
    title: "Sign In",
  },
});

function SignInPage() {
  const navigate = useNavigate();

  return (
    <SignInForm
      auth={auth}
      onSuccess={(_, requiresVerification) => {
        // Track login in Google Analytics
        logEvent(analytics, "login", {
          method: "email",
        });

        if (requiresVerification) {
          navigate({ to: "/verification" });
        } else {
          navigate({ to: "/dashboard" });
        }
      }}
      onForgotPasswordClick={() => navigate({ to: "/forgot" })}
      onSignUpClick={() => navigate({ to: "/signup" })}
    />
  );
}
